import { Avatar, Card, CardContent, Icon, Typography, withStyles } from '@material-ui/core';
import XAPPDialog from 'app/Core/Components/Dialog/XAPPDialog';
import XAPPComponent from 'app/Core/Components/XAPPComponent/XAPPComponent';
import * as APPActions from 'app/store/actions';
import classNames from 'classnames';
import MobileDetect from 'mobile-detect';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import LoginFirebase from '../../Funcionalidade/Auth/login/LoginFirebase';
import XAPPButton from '../Button/XAPPButton';
import * as Actions from './Store/Actions/ScreenLockActions';

const md = new MobileDetect(window.navigator.userAgent);

const styles = theme => ({
    root: {
        color: theme.palette.primary.contrastText
    },
    fontColor: {
        color: theme.palette.type === "dark" ? "#C7C7C7" : "#757575",
        textDecoration: 'none',
        '&:hover': {
            color: theme.palette.type === "dark" ? "#C7C7C7" : "#757575"
        }
    }
});

class LockPage extends XAPPComponent {

    getCallback = () => {
        this.props.openDialog(false);
    }

    openDialog = (_AValue) => {
        // navigator.setClientBadge(14);
        this.props.openDialog(_AValue);
    }

    render() {
        const { classes, open, user } = this.props;

        return (
            <React.Fragment>
                <XAPPButton
                    className=""
                    type="icon"
                    key="lock"
                    tooltip={{ placement: "top", title: "Bloquear sessão" }}
                    color="action"
                    onClick={() => this.openDialog(true)}
                    icon={"lock"}
                    iconProps={"text-16 font-bold"}
                />
                <XAPPDialog
                    id="LookPage"
                    open={open}
                    fullWidth
                    maxWidth="xs"
                    fullScreen={md.mobile() !== null}
                >
                    <div className={classNames(classes.root, "flex flex-col flex-auto flex-no-shrink items-center justify-center")}>

                        <div className="flex flex-col items-center justify-center w-full">

                            <Card className="w-full max-w-sm">

                                <CardContent className="flex flex-col items-center justify-center">

                                    <div className="w-full flex flex-col items-center justify-center sm:flex-row sm:justify-start sm:items-center pb-8">

                                        <div className="relative mr-16">
                                            <Avatar
                                                className="w-72 h-72"
                                                alt={user.nome}
                                                src={user.foto !== null && user.foto.length > 0 ? user.foto : "assets/images/avatars/profile.png"}
                                            />
                                            <Icon className="text-32 absolute pin-r pin-b" color="error">lock</Icon>
                                        </div>
                                        <div>
                                            <Typography variant="h6" className="mb-8">SESSÃO BLOQUEADA</Typography>
                                            <Typography color="textSecondary">
                                                Por inatividade sua sessão foi bloqueada, por favor acesse novamente.
                                            </Typography>
                                        </div>
                                    </div>
                                    <LoginFirebase
                                        callback={this.getCallback}
                                        lockUser={true}
                                    />
                                </CardContent>
                            </Card>
                        </div>
                    </div>
                </XAPPDialog>
            </React.Fragment>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        openDialog: Actions.openDialog,
        showMessage: APPActions.showMessage,
    }, dispatch);
}

function mapStateToProps({ ScreenLock, auth }) {
    return {
        open: ScreenLock.open,
        user: auth.user.data
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(LockPage)));
